// extracted by mini-css-extract-plugin
export var contrastLow = "_37-1";
export var externalLink = "_37-2";
export var externalLinkIcon = "_37-3";
export var link = "_37-0";
export var linkLabel = "_37-4";